import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      {/* SEO */}
      <SEO
        title="Terms & Conditions | Lubrichem"
        description="Read the terms and conditions governing the use of Lubrichem's website, products, and services."
        url="https://yourdomain.com/terms-and-conditions"
      />

      {/* HERO */}
      <section className="terms-hero">
        <div className="container text-center">
          <h1>Terms & Conditions</h1>
          <p>Please read these terms carefully before using our website.</p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="terms-content">
        <div className="container">
          <div className="terms-card">
            <p className="updated">Last updated: March 2025</p>

            <h3>1. Introduction</h3>
            <p>
              Welcome to <strong>Lubrichem</strong>. By accessing or using this
              website, you agree to be bound by these Terms & Conditions. If you
              do not agree, please do not use our website.
            </p>

            <h3>2. Use of Website</h3>
            <p>
              This website is intended to provide information about our
              industrial lubricants, chemicals, and related services. You agree
              not to misuse the website or use it for unlawful purposes.
            </p>

            <h3>3. Product Information</h3>
            <p>
              All product descriptions, specifications, and technical data are
              provided for general information purposes only. Actual product
              performance may vary based on application and operating
              conditions.
            </p>

            <h3>4. Intellectual Property</h3>
            <p>
              All content on this website, including text, images, logos, and
              designs, is the property of Lubrichem and is protected by
              intellectual property laws. Unauthorized use is strictly
              prohibited.
            </p>

            <h3>5. Third-Party Links</h3>
            <p>
              Our website may contain links to third-party websites. We are not
              responsible for the content, policies, or practices of any
              third-party sites.
            </p>

            <h3>6. Limitation of Liability</h3>
            <p>
              Lubrichem shall not be liable for any direct, indirect,
              incidental, or consequential damages arising from the use or
              inability to use this website or our products.
            </p>

            <h3>7. Indemnification</h3>
            <p>
              You agree to indemnify and hold Lubrichem harmless from any
              claims, damages, or expenses arising out of your use of this
              website.
            </p>

            <h3>8. Changes to Terms</h3>
            <p>
              We reserve the right to update or modify these Terms & Conditions
              at any time without prior notice. Continued use of the website
              constitutes acceptance of the updated terms.
            </p>

            <h3>9. Governing Law</h3>
            <p>
              These terms shall be governed by and construed in accordance with
              the laws of India. Any disputes shall be subject to the exclusive
              jurisdiction of Indian courts.
            </p>

            <h3>10. Contact Information</h3>
            <p>
              If you have any questions regarding these Terms & Conditions,
              please contact us via our <Link to="/contact">Contact Page</Link>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
